import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import "./style.scss";
import { ErrorMessage } from "../ErrorMessage";
import { CustomButton } from "../../../../components/ui-kit/CustomButtom";
import { TermsAndConditionsFooter } from "../TermsAndConditionFooter";

import { useTranslation } from 'react-i18next';

export const AuthFormAccessCode = ({
  handleGoBack,
  handleLoginWithAccessCode,
  handleChange,
  errorMessage,
  hasError,
  disableLogin_3_sec,
}) => {

  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  const { t } = useTranslation();

  useEffect(() => {
    if (disableLogin_3_sec) {
      setIsButtonDisabled(true);
      setTimeout(function() {
        setIsButtonDisabled(false);
      }, 3000);
    }

  }, [disableLogin_3_sec]);

  return (
    <div className="auth-form-access-code">
      <div className="auth-form__header">
        <h2 className="heading heading-1">{t("Access Your Account")}</h2>
        <p className="heading heading-body-medium">
          {t("Please enter the access code you received or chat with us to get a code")}
        </p>
        {hasError ? <ErrorMessage errorMessage={errorMessage} /> : null}
      </div>
      <div className="form-group">
        <label htmlFor="zip">{t("Access Code")}</label>
        <input
          type="text"
          className="form-control"
          id="access_code"
          name="access_code"
          placeholder="XXXXXX"
          onChange={handleChange}
        />
      </div>
      <div className="auth-form__submit">
        <CustomButton
          onClickHandler={() => handleLoginWithAccessCode()}
          buttonId="submit-button"
          text={t("Access Account")}
          disabled={isButtonDisabled}
        />
        <CustomButton
          buttonId="access-code-btn"
          text={t("I don’t have an access code")}
          onClickHandler={() => handleGoBack()}
        />
      </div>
      <TermsAndConditionsFooter/>
    </div>
  );
};

AuthFormAccessCode.propTypes = {
  handleGoBack: PropTypes.func,
  handleLoginWithAccessCode: PropTypes.func,
  handleChange: PropTypes.func,
  errorMessage: PropTypes.string,
  hasError: PropTypes.bool,
  disableLogin_3_sec: PropTypes.bool,
};
